import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  media: {
    height: 10,
    width: 'auto',
    paddingTop: '63.25%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backgroundBlendMode: 'exclusion',
  },
  border: {
    border: 'solid',
  },
  fullHeightCard: {
    height: '100%',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '15px',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    alignContent: 'center',
    '&:hover' : { transform: 'scale(1.1)' }
  },
  overlay: {
    position: 'absolute',
    top: '20px',
    left: '20px',
    color: 'white',
  },
  overlay2: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    color: 'white',
  },
  grid: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '20px',
  },
  address: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px',
  },
  title: {
    padding: '0 16px',
  },
  cardActions: {
    padding: '0 16px 8px 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardAction: {
    display: 'block',
    width: '100% !important',
    textAlign: 'initial',
    flexGrow: 1
  },
});